import { render, staticRenderFns } from "./SubmissionsFilters.vue?vue&type=template&id=52a8fc26&scoped=true&"
import script from "./SubmissionsFilters.vue?vue&type=script&lang=js&"
export * from "./SubmissionsFilters.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionsFilters.vue?vue&type=style&index=0&id=52a8fc26&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a8fc26",
  null
  
)

export default component.exports